// NOTE: hooks
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
// NOTE: components
import ResourcesCard from './ResourcesCard'
import { PiMagnifyingGlassBold as ExploreIcon } from 'react-icons/pi'
import { Carousel, SwiperSlide } from '../../components/ui/carousel/Carousel'

interface ResourcesListProps {
    resources: any
}

const tags = [
	"all",
	"fitness",
	"sleep",
	"giving",
	"fun",
	"relaxation",
	"risks",
	"nutrition",
	"nature",
	"relationships",
	"mindfulness"
]

const ResourcesList = ({ resources }: ResourcesListProps) => {
    const [urlParams, setUrlParams] = useSearchParams()
    const [selectedTag, setSelectedTag] = useState(() =>
        tags.includes(urlParams.get('tag') ?? '') ? urlParams.get('tag') : 'all'
    )
    const [filteredResources, setFilteredResources] = useState<any>([])

    const filterTags = (tag: any) => {
        if (!resources) return

        if (tag === 'all') return setFilteredResources(resources)

        const filterResources = (resources ?? []).filter((resource: any) => resource?.tags?.some((tags: any) => tags?.name?.toLowerCase() === tag))
        setFilteredResources(filterResources)
    }

    const changeTags = (tag: any) => {
        urlParams.set('tag', tag)
        setUrlParams(urlParams)
        setSelectedTag(tag)
        filterTags(tag)
    }

    useEffect(() => {
        filterTags(selectedTag)
    }, [resources])

    return (
        <>
            <div className="mb-6">
                <Carousel>
                    {tags.map((tag: any, index: any) => (
                        <SwiperSlide key={index} style={{ width: 'fit-content', minWidth: 'fit-content' }}>
                            <button
                                className={`mr-2 flex w-fit rounded-full px-5 py-2 text-center font-semibold capitalize shadow-sm md:mr-4 ${selectedTag === tag
                                    ? 'text-dark hover:text-dark bg-gradient-to-r from-clay-100 to-orange-100'
                                    : 'bg-gradient-to-r from-[#f0f0fa] to-[#e8f2f4] text-green-900 hover:text-green-900'
                                    }`}
                                onClick={() => changeTags(tag)}
                            >
                                {tag}
                            </button>
                        </SwiperSlide>
                    ))}
                </Carousel>
            </div>
            {filteredResources && filteredResources.length > 0 && (
                <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
                    {filteredResources?.map((resource: any) => (
                        <ResourcesCard
                            key={resource.id}
                            title={resource.title}
                            cover={resource.cover}
                            dek={resource.dek}
                            pdf={resource.pdf}
                            className="mb-10 sm:mb-6"
                            thumbnailClassName="h-[320px] w-full"
                        />
                    ))}
                </div>
            )}
            {(!filteredResources || filteredResources.length === 0) && (
                <>
                    <ExploreIcon className="mx-auto mt-4 size-16 text-slate-400" />

                    <p className="mb-12 text-center text-lg font-semibold text-slate-500">
                        No content found
                    </p>
                </>
            )}
        </>
    )
}

export default ResourcesList